"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledMailDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var hooks_1 = require("./hooks");
var internal_1 = require("./hooks/internal");
var internal_2 = require("../internal");
exports.ScheduledMailDialog = function (props) {
    var _a, _b;
    var backend = props.backend, workspace = props.workspace, locale = props.locale, dashboardRef = props.dashboard, filters = props.filters, onSubmit = props.onSubmit, onSubmitSuccess = props.onSubmitSuccess, onSubmitError = props.onSubmitError, onCancel = props.onCancel, onError = props.onError, isVisible = props.isVisible;
    var _c = internal_1.useCurrentUser({
        backend: backend,
    }), currentUser = _c.result, currentUserStatus = _c.status, currentUserError = _c.error;
    var _d = hooks_1.useDashboard({
        backend: backend,
        workspace: workspace,
        dashboard: dashboardRef,
    }), dashboard = _d.result, dashboardStatus = _d.status, dashboardError = _d.error;
    var _e = internal_1.useUserWorkspacePermissions({ backend: backend, workspace: workspace }), permissions = _e.result, permissionsStatus = _e.status, permissionsError = _e.error;
    var _f = internal_1.useUserWorkspaceSettings({ backend: backend, workspace: workspace }), featureFlags = _f.result, featureFlagsStatus = _f.status, featureFlagsError = _f.error;
    var _g = react_1.useState(), submittedScheduledMail = _g[0], setSubmittedScheduledMail = _g[1];
    var filterContextToSave = react_1.useMemo(function () {
        if (filters) {
            return {
                title: "filterContext",
                description: "",
                filters: filters,
            };
        }
        return undefined;
    }, [filters]);
    internal_1.useSaveScheduledMail({
        scheduledMail: submittedScheduledMail,
        filterContext: filterContextToSave,
        onSuccess: onSubmitSuccess,
        onError: onSubmitError,
        backend: backend,
        workspace: workspace,
    });
    var error = (_b = (_a = currentUserError !== null && currentUserError !== void 0 ? currentUserError : dashboardError) !== null && _a !== void 0 ? _a : permissionsError) !== null && _b !== void 0 ? _b : featureFlagsError;
    var effectiveLocale = locale !== null && locale !== void 0 ? locale : featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.locale;
    var isLoading = [currentUserStatus, dashboardStatus, permissionsStatus, featureFlagsStatus].some(function (status) { return status === "loading" || status === "pending"; });
    react_1.useEffect(function () {
        if (error && onError) {
            onError(error);
        }
    }, [error]);
    var handleSubmit = react_1.useCallback(function (scheduledMail) {
        setSubmittedScheduledMail(scheduledMail);
        if (onSubmit) {
            onSubmit(scheduledMail);
        }
    }, [onSubmit]);
    // Bear model expects that all refs are sanitized to uriRefs.
    var dashboardUriRef = react_1.useMemo(function () { return (dashboard ? sdk_model_1.uriRef(dashboard.uri) : null); }, [dashboard]);
    // trigger the invariant only if the user tries to open the dialog
    if (featureFlags && isVisible) {
        ts_invariant_1.default(featureFlags.enableKPIDashboardSchedule, "Feature flag enableKPIDashboardSchedule must be enabled to make ScheduledMailDialog work properly.");
    }
    if (!isVisible) {
        return null;
    }
    if (isLoading) {
        return (react_1.default.createElement(sdk_ui_kit_1.Overlay, { className: "gd-schedule-email-dialog-overlay", isModal: true, positionType: "fixed" },
            react_1.default.createElement(sdk_ui_1.LoadingComponent, null)));
    }
    if (error) {
        return (react_1.default.createElement(sdk_ui_kit_1.Overlay, { className: "gd-schedule-email-dialog-overlay", isModal: true, positionType: "fixed" },
            react_1.default.createElement(sdk_ui_1.ErrorComponent, { message: error.message })));
    }
    return currentUser ? (react_1.default.createElement(internal_2.ScheduledMailDialogRenderer, { backend: backend, workspace: workspace, locale: effectiveLocale, canListUsersInProject: permissions === null || permissions === void 0 ? void 0 : permissions.canListUsersInProject, enableKPIDashboardScheduleRecipients: featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableKPIDashboardScheduleRecipients, dateFormat: featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.responsiveUiDateFormat, currentUser: currentUser, dashboard: dashboardUriRef, dashboardTitle: dashboard === null || dashboard === void 0 ? void 0 : dashboard.title, onSubmit: handleSubmit, onCancel: onCancel, onError: onError })) : null;
};
//# sourceMappingURL=ScheduledMailDialog.js.map